enum ArcgisWayBackIntegrationStatus {
  active = 'active',
  archived = 'archived',
}

export default ArcgisWayBackIntegrationStatus
